import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  icon: '🛒',
  number: '01',
  title: 'Complete your payment',
  description: 'Enter your payment details. At checkout, the price is automatically converted to your local currency. You can review the exact amount before confirming your purchase. Pay securely by credit or debit card.'
}, {
  icon: '📥',
  number: '02',
  title: 'Download instantly',
  description: 'You get immediate access to all 10 PDF files as soon as your payment is confirmed. No waiting, no app required, and no subscription. Access everything from any device, anywhere in the world.'
}, {
  icon: '🎓',
  number: '03',
  title: 'Transform your teaching',
  description: 'Start using the system in your very next class and teach with greater structure, confidence and clarity from day one.'
}];
export function HowItWorks() {
  return <section className="w-full bg-navy px-5 py-12 sm:py-20" data-id="element-113" data-mp="19bffnarex6fp">
      <div className="mx-auto max-w-5xl" data-id="element-114" data-mp="2rl4sevnvlr0q">
        <div className="mx-auto max-w-2xl text-center" data-id="element-115" data-mp="2rm7jp4p41vh6">
          <h2 className="font-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-116" data-mp="2mn37042z9fm3">
            How does it work?
          </h2>
          <p className="mt-3 text-sm text-white/70 sm:text-base" data-id="element-117" data-mp="31d26qba6kz3o">
            Simple, instant and available worldwide.
          </p>
        </div>
        <div className="mt-12 flex flex-col gap-8 md:flex-row md:gap-6" data-id="element-118" data-mp="3abvx3jwx4t8s">
          {steps.map((step, index) => <React.Fragment key={step.number} data-id="element-119" data-mp="36bc0chg9brn6" data-mpi={index}>
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.3,
            delay: index * 0.06,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-1 flex-col items-center text-center" data-id="element-120" data-mp="36cn44h9pczea">
                <span className="flex h-16 w-16 items-center justify-center rounded-full border border-gold/50 bg-navy-mid text-3xl" data-id="element-121" data-mp="1ky95iev5bc5o">
                  {step.icon}
                </span>
                <span className="mt-4 font-display text-2xl font-bold text-gold" data-id="element-122" data-mp="3pxs79osy02fm">{step.number}</span>
                <h3 className="mt-2 text-lg font-bold text-white" data-id="element-123" data-mp="3tzvrp2xlahd1">{step.title}</h3>
                <p className="mt-3 max-w-xs text-sm leading-relaxed text-white/70" data-id="element-124" data-mp="2udmvdtwwnpl">
                  {step.description}
                </p>
              </motion.div>
              {index < steps.length - 1 && <div className="mx-auto h-8 w-px bg-gold/35 md:hidden" aria-hidden="true" data-id="element-125" data-mp="cr8j1q2pqc0p" />}
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}